export default __webpack_public_path__ + "static/media/6.58d65845.png";